
import { HttpManageWareList, HttpExportManageWare } from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import comIndex from './update'

import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpManageWareList,
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        activeids: params,
                        querytype: 'query',
                        title: "消息查看",
                        component: "comIndex",
                        width: 'large',
                        showFooter: false
                    };
                    break;
                case "queryBlank":
                    let url = this.$router.resolve({
                        name: "basicdataManagewareUpdate",
                        params: { type: "query" },
                        query: { id: params }
                    });
                    window.open(url.href, "_blank");
                    break;
                case "export":
                    this.handleWebfs(
                        HttpExportManageWare,
                        this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: "查看" }),
                    params: id,
                    operate: 'queryBlank',
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    // params: id,
                    show: true,
                    to: {
                        name: "basicdataManagewareUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList']),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.operate_add', { defaultValue: "添加" }),
                    // operate: "add",
                    theme: "primary",
                    to: {
                        name: "basicdataManagewareUpdate",
                        params: {
                            type: 'add'
                        }
                    }
                },
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.warehouse_type', { defaultValue: "仓库类型" }),
                    key: 'EQ_warehouseType',
                    tag: 'vSelect',
                    show: true,
                    options: this.getWarehouseTypes,
                },
                {
                    label: this.$t('fbb.warehouse.warehouse_code', { defaultValue: "仓库代码" }),
                    key: 'CN_code',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
                    key: 'CN_title',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.warehouse.status', { defaultValue: "活动状态" }),
                    key: 'EQ_active',
                    tag: 'vSelect',
                    options: this.getWarehouseActive,
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:262px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.inbound.warehouse_type', { defaultValue: "仓库类型" }),
                    key: 'warehouseType',
                    render: (h, { row }) => this.findRenderLabel(this.getWarehouseTypes, row.warehouseType),
                },
                {
                    title: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
                    key: 'title',
                },
                {
                    title: this.$t('fbb.warehouse.warehouse_code', { defaultValue: "仓库代码" }),
                    key: 'code',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.code || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                // {
                //     title: this.$t('fbb.warehouse.owner_org', { defaultValue: "所属管理方" }),
                //     key: "hostOrgId",
                //     render: (h, { row }) =>this.$store.state.organization.name,
                // },
                {
                    title: this.$t('fbb.warehouse.status', { defaultValue: "活动状态" }),
                    key: "active",
                    render: (h, { row }) => this.findRenderLabel(this.getWarehouseActive, row.active),
                },
                {
                    title: this.$t('fbb.warehouse.property', { defaultValue: "仓库属性" }),
                    key: 'property',
                    render: (h, { row }) => {
                        const result = [];
                        const propertys = (row.property || '').split('|');
                        this.getWarehouseAttrs.forEach(item => {
                            if (propertys.some(val => val == item.value)) {
                                result.push(item.label);
                            }
                        })
                        return result.join('，') || '--';
                    },
                },
                {
                    title: this.$t('global.common.currency', { defaultValue: "币种" }),
                    key: 'currencyDefault',
                },
                {
                    title: this.$t('', { defaultValue: "仓库预约邮箱" }),
                    key: 'contactEmail',
                    render: (h, { row }) => row.contactEmail || '--',
                },
                {
                    title: this.$t('fbb.accountmanage.description', { defaultValue: "描述" }),
                    key: 'description',
                    render: (h, { row }) => row.description || '--',
                },
                {
                    title: this.$t('fbb.warehouse.closing_time', { defaultValue: "截单时间（UTC）" }),
                    key: 'closingTime',
                    render: (h, { row }) => row.closingTime || '--',
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: "创建人" }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    key: 'createdAt',
                }];
        },
    },
};




